export function getUserErrorMessage(error) {
  const code = error?.code || error?.error?.code || '';
  const status = error?.status || error?.error?.status || 0;
  const message = String(error?.message || '');

  if (status === 429 || code === 'savorasrv_rate_limited' || message.includes('429')) {
    return 'Too many requests. Please wait a moment and try again.';
  }

  if (status === 401 || message.includes('401')) {
    return 'Your session has expired. Please log in again.';
  }

  if (status === 403 || message.includes('403')) {
    return 'You do not have access to this Savora pilot.';
  }

  return 'Something went wrong. Please try again.';
}
